import { ItemDate } from '@centerpiece/components';

export interface Subscription {
  id: number;
  created_at: string;
  updated_at: string;
  deleted: boolean;
}

export enum ROLETYPE {
  'Internal',
  'External',
}

export interface Billing {
  id: number;
  created_at: string;
  updated_at: string;
  project: number;
  item?: number;
  type: number;
  amount: number;
  deleted: boolean;
}

export interface Payment {
  id: number;
  created_at: string;
  updated_at: string;
  project: number;
  item?: number;
  type: number;
  amount: number;
  deleted: boolean;
}

export interface Role {
  id: number;
  created_at: string;
  updated_at: string;
  name: string;
  type: string;
  deleted: boolean;
  subscription: number;
}

export interface Organization {
  id: number;
  created_at: string;
  updated_at: string;
  name: string;
  type: string;
  deleted: boolean;
  subscription: number;
  form: any;
  role_r: Role;
  role: number;
}

export interface MarketSegment {
  id: number;
  created_at: string;
  updated_at: string;
  name: string;
  project_type: number;
  project_type_r: ProjectType;
  subscription: number;
  deleted: boolean;
}

export interface Contact {
  id: number;
  created_at: string;
  updated_at: string;
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
  role: number;
  role_r: Role;
  author: boolean;
  message_type: string;
  status: string;
  partstat: string;
  form: any;
  organization: number;
  organization_r: Organization;
  enterprise: Enterprise;
}

export interface Subscriber {
  id: number;
  created_at: string;
  updated_at: string;
  subscription: number;
  login: number;
  contact_r: Contact;
  enterprise_r: Enterprise;
  role: number;
  role_r: Role;
  deleted: boolean;
}

export interface Enterprise {
  id: number;
  created_at: string;
  updated_at: string;
  subscription: number;
  company: string;
  deleted: boolean;
  form: any;
}

export interface ProjectStage {
  id: number;
  created_at: string;
  updated_at: string;
  name: string;
  deleted: boolean;
  subscription?: number;
  awarded: boolean;
  outcomes: Outcome[];
  title: string;
}
export interface ProjectStateReason {
  id: number;
  created_at: string;
  updated_at: string;
  name: string;
  deleted: boolean;
  subscription: number;
  state: number;
}
export interface ProjectState {
  id: number;
  created_at: string;
  updated_at: string;
  name: string;
  deleted: boolean;
  subscription?: number;
  awarded: boolean;
  reasons?: ProjectStateReason[];
}
export const PROJECTSTATES = {
  COMPLETE: 1,
  CANCELED: 2,
  ACTIVE: 3,
  LOST: 4,
};

export interface Outcome {
  id: number;
  created_at: string;
  updated_at: string;
  name: string;
  deleted: boolean;
  stage: number;
  state: number;
  state_r: ProjectState;
  stage_r: ProjectStage;
  awarded: boolean;
  complete: boolean;
}

export interface Content {
  project: Project;
  grouping: Grouping;
  item: Item;
  task: Task;
  event: Event;
  coordination: Coordination;
}

export interface Project {
  contents: Content[];
  id: number;
  created_at: string;
  updated_at: string;
  deleted: boolean;
  archived: boolean;
  title: string;
  active: boolean;
  details: string;
  // stage: number;
  state: number;
  // stage_r: ProjectStage;
  state_r: ProjectState;
  due_date: string;
  install_date: string;
  subscription: number;
  contact: number;
  contacts: ProjectContact[];
  stages: Stage[];
  groupings: Grouping[];
  events: Event[];
  coordinations: Coordination[];
  items: Item[];
  messages: Message[];
  comments: Comment[];
  all_items: Item[];
  contact_r: Contact;
  attachments: Attachment[];
  files: File[];
  category: string;
  type: number;
  contract_type: number;
  type_r: ProjectType;
  template: boolean;
  template_r: ProjectTemplate;
  team_ids: number[];
  teams: Team[];
  market_segment: number;
  market_segment_r: MarketSegment;
  item_counts: ItemCount[];
  form: any;
  msgs: MessageContact[];
  cmts: CommentContact[];
}

export interface ItemCount {
  count: number;
  status: string;
  status_r: ItemStatus;
  project: number;
}

export interface ProjectTemplate {
  id: number;
  created_at: string;
  updated_at: string;
  project: number;
  name: string;
  details: string;
  deleted: boolean;
}

export interface ProjectContact {
  id: number;
  created_at: string;
  updated_at: string;
  project: number;
  contact: number;
  contact_r: Contact;
  role: number;
  role_r: Role;
  deleted: boolean;
  form: any;
  organization: number;
  organization_r: Organization;
  avatar: any;
}

export interface ProjectWorkflow {
  id: number;
  created_at: string;
  updated_at: string;
  project: number;
  contact: number;
  contact_r: Contact;
  role: number;
  role_r: Role;
  deleted: boolean;
  form: any;
  organization: number;
  organization_r: Organization;
  avatar: any;
}

export interface Tag {
  id: number;
  created_at: string;
  updated_at: string;
  name: string;
  subscription: number;
  deleted: boolean;
}

export interface Team {
  id: number;
  created_at: string;
  updated_at: string;
  name: string;
  subscription: number;
  deleted: boolean;
}

export interface TeamContact {
  id: number;
  created_at: string;
  updated_at: string;
  team: number;
  team_r: Team;
  contact: number;
  contact_r: Contact;
  role: number;
  role_r: Role;
  deleted: boolean;
}

export interface SubscriptionContact {
  id: number;
  created_at: string;
  updated_at: string;
  subscription: number;
  contact: number;
  contact_r: Contact;
  role: number;
  role_r: Role;
  deleted: boolean;
  organization: number;
  organization_r: Organization;
}

export interface ProjectTeam {
  id: number;
  created_at: string;
  updated_at: string;
  project: number;
  team: number;
  deleted: boolean;
  team_r: Team;
}

export interface ProjectType {
  id: number;
  created_at: string;
  updated_at: string;
  name: string;
  win_loss: boolean;
  estimated_win_rate: number;
  target_gmr: number;
  deleted: boolean;
}

export interface ContractType {
  id: number;
  created_at: string;
  updated_at: string;
  name: string;
  deleted: boolean;
}
export interface BillingType {
  id: number;
  created_at: string;
  updated_at: string;
  name: string;
  deleted: boolean;
}
export interface PaymentType {
  id: number;
  created_at: string;
  updated_at: string;
  name: string;
  deleted: boolean;
}
export interface Stage {
  id: number;
  created_at: string;
  updated_at: string;
  start_date: string;
  due_date: string;
  project: number;
  item: number;
  items: Item[];
  outcome: number;
  contact_r: Contact;
  contact: number;
  deleted: boolean;
  project_r: Project;
  stage_r: ProjectStage;
  outcome_r: Outcome;
  sequence: number;
  title: string;
  name: string;
  form: any;
}

export interface Grouping {
  id: number;
  created_at: string;
  updated_at: string;
  title: string;
  status: string;
  due_date: string;
  project: number;
  sequence: number;
  items: Item[];
  // events: Event[];
  // coordinations: Coordination[];
  contact_r: Contact;
  contact: number;
  deleted: boolean;
  project_r: Project;
}

export interface ItemStatus {
  id: number;
  created_at: string;
  updated_at: string;
  name: string;
  deleted: boolean;
}

export const ITEMSTATUSES = {
  NOTSTARTED: 1,
  INPROGRESS: 2,
  COMPLETE: 3,
};

export interface ItemTag {
  id: number;
  created_at: string;
  updated_at: string;
  item: number;
  tag: number;
  item_r: Item;
  tag_r: Tag;
  deleted: boolean;
}

export interface Item {
  id: number;
  created_at: string;
  updated_at: string;
  start_date: string;
  due_date: string;
  title: string;
  details: string;
  status: number;
  status_r: ItemStatus;
  item: number;
  items: Item[];
  grouping: number;
  project: number;
  sequence: number;
  coordination_r: Coordination;
  si_coordination_r: Coordination;
  event_r: Event;
  si_event_r: Event;
  contact_r: Contact;
  contact: number;
  deleted: boolean;
  stage_r: Stage;
  grouping_r: Grouping;
  project_r: Project;
  task_r: Task;
  si_task_r: Task;
  attachments: Attachment[];
  si_relationships: Relationship[];
  messages: Message[];
  message_r: Message;
  responses: Response[];
  appointments: Appointment[];
  appointment_r: Appointment;
  msgs: number;
  cmts: number;
  masked?: boolean;
  tags?: Tag[];
  archived?: boolean;
  form?: any;
}

export interface NodeItem {
  id: number;
  created_at: string;
  updated_at: string;
  deleted: boolean;
  archived: boolean;
  status: ItemStatus;
  item: number;
  sequence: number;
  items: NodeItem[];
  dates?: ItemDate[];
  project: number;
  stage: Stage;
  grouping: Grouping;
  coordination: Coordination;
  event: Event;
  task: Task;
  attachments: Attachment[];
  relationships: Relationship[];
  msgs: number;
  cmts: number;
  complete?: boolean;
  masked?: boolean;
  nodeType: string;
  parentId?: number;
  parentNodeType?: string;
  messages?: Message[];
  responses?: Response[];
  appointments?: Appointment[];
}

export interface Task {
  id: number;
  created_at: string;
  updated_at: string;
  deleted: boolean;
  archived: boolean;
  title: string;
  details: string;
  status: number;
  status_r: ItemStatus;
  items: Item[];
  grouping: number;
  project: number;
  sequence: number;
  start_date: string;
  due_date: string;
  coordinations: Coordination[];
  events: Event[];
  contact_r: Contact;
  contact: number;
  grouping_r: Grouping;
  project_r: Project;
  item: number;
  item_r: Item;
  form: any;
  attachments: Attachment[];
  comments: Comment[];
  relationships: Relationship[];
}

export enum EVENTTYPE {
  'Availability',
  'Scheduling Confirmation',
}

export interface Event {
  id: number;
  created_at: string;
  updated_at: string;
  deleted: boolean;
  archived: boolean;
  title: string;
  details: string;
  status: number;
  e_status_r: ItemStatus;
  project: number;
  grouping: number;
  item: number;
  sequence: number;
  start_date: string;
  due_date: string;
  e_owner: Contact;
  contact: number;
  e_grouping_r: Grouping;
  e_project_r: Project;
  e_item_r: Item;
  e_messages: Message[];
  e_responses: Response[];
  e_relationships: Relationship[];
  e_attachments: Attachment[];
  e_comments: Comment[];
  form: any;
  type: string;
}

export interface Coordination {
  id: number;
  created_at: string;
  updated_at: string;
  deleted: boolean;
  archived: boolean;
  title: string;
  details: string;
  status: number;
  crd_status_r: ItemStatus;
  project: number;
  grouping: number;
  item: number;
  sequence: number;
  start_date: string;
  due_date: string;
  crd_owner: Contact;
  contact: number;
  crd_grouping_r: Grouping;
  crd_project_r: Project;
  crd_item_r: Item;
  crd_messages: Message[];
  crd_responses: Response[];
  crd_relationships: Relationship[];
  crd_attachments: Attachment[];
  crd_comments: Comment[];
  form: any;
  type: string;
}

export enum RELATIONSHIPTYPE {
  'Owner',
  'Assigned',
  'Watcher',
}

export interface Relationship {
  id: number;
  created_at?: string;
  updated_at?: string;
  deleted: boolean;
  status: number;
  item?: number;
  event?: number;
  coordination?: number;
  contact: number;
  role?: number;
  contact_r?: Contact;
  contacts?: Contact[];
  role_r: Role;
  type: RELATIONSHIPTYPE;
  project_r: Project;
  event_r: Event;
  task_r: Task;
  coordination_r: Coordination;
  status_r: ItemStatus;
  messages: Message[];
  comments: Comment[];
  stages: Stage[];
  relationships: Relationship[];
  form: any;
  variant?: string;
  group?: string;
  title?: string;
  start_date?: any;
  due_date?: any;
}

export interface Avatar {
  type: string;
}

export interface MessageContact {
  id: number;
  created_at: string;
  updated_at: string;
  message: number;
  author: boolean;
  contact: number;
  message_type: string;
  code: string;
  status: string;
  contact_r: Contact;
  message_r: Message;
  response_r: Response;
  item: Item;
  count: number;
}

export interface AppointmentContact {
  id: number;
  created_at: string;
  updated_at: string;
  message: number;
  author: boolean;
  contact: number;
  message_type: string;
  code: string;
  status: string;
  contact_r: Contact;
  appt_r: Appointment;
  item: Item;
}

export interface Response {
  id: number;
  contact_r: Contact;
  contact: number;
  deleted: boolean;
  message: number;
  r_message_r: Message;
  contacts: Contact[];
  reactions: Reaction[];
  created_at: string;
  updated_at: string;
  form: any;
  attachments: Attachment[];
}

export interface Reaction {
  id: number;
  action: number;
  status: string;
  contact: number;
  deleted: boolean;
  details: string;
  mentions: any[];
  response: number;
  created_at: string;
  updated_at: string;
  action_r: Action;
  reactionattachments: Attachment[];
  attachments: Attachment[];
  form: any;
}

export enum MESSAGESTATUS {
  'New',
  'Read',
  'Replied',
  'Complete',
}

export interface Message {
  id: number;
  created_at: string;
  updated_at: string;
  coordination: number;
  status: MESSAGESTATUS;
  subject: string;
  contact: number;
  actions: Action[];
  contacts: Contact[];
  contact_r: Contact;
  coordination_r: Coordination;
  event: number;
  event_r: Event;
  form: any;
  deleted: boolean;
  details: any;
  due_date: any;
  sequence: number;
  type: any;
}

export interface Appointment {
  id: number;
  created_at?: Date;
  updated_at?: Date;
  deleted?: boolean | null;
  uid?: string;
  item?: number;
  title?: string;
  details?: string | null;
  start_time?: Date;
  end_time?: Date;
  location?: string;
  contact?: number | null;
  form?: any;
  coordination: number;
  status: MESSAGESTATUS;
  subject: string;
  actions: Action[];
  contacts: Contact[];
  contact_r: Contact;
  coordination_r: Coordination;
  event: number;
  event_r: Event;
  due_date: any;
  sequence: number;
  type: any;
  attachments: Attachment[];
}

export enum SENDTYPE {
  'TO',
  'CC',
  'BCC',
}

export enum ACTIONSTATUS {
  'New',
  'In Progress',
  'POSTPONED',
  'Complete',
}

export interface Action {
  id: number;
  created_at: string;
  updated_at: string;
  deleted: boolean;
  status: ACTIONSTATUS;
  message: number;
  title: string;
  details: string;
  sequence: number;
  message_r: Message;
  attachments: Attachment[];
  form: any;
}

export interface CustomInput {
  id: number;
  created_at: string;
  updated_at: string;
  deleted: boolean;
  action: number;
  details: JSON;
}

export interface CustomInputResponse {
  id: number;
  created_at: string;
  updated_at: string;
  deleted: boolean;
  contents: string;
  response: number;
  custom_input: number;
  contact: number;
}

export interface Comment {
  id: number;
  created_at: string;
  updated_at: string;
  deleted: boolean;
  project: number;
  contact: number;
  item: number;
  event: number;
  coordination: number;
  task: number;
  action: number;
  comment: string;
  contacts: CommentContact[];
}

export interface CommentContact {
  id: number;
  created_at: string;
  updated_at: string;
  comment: number;
  author: boolean;
  contact: number;
  status: string;
  contact_r: Contact;
  item: Item;
  count: number;
}

export interface Mention {
  id: number;
  created_at: string;
  updated_at: string;
  deleted: boolean;
  contact: number;
  item: number;
  event: number;
  coordination: number;
  action: number;
  comment: number;
}

export interface Attachment {
  id: number;
  deleted: boolean;
  created_at: string;
  updated_at: string;
  file: File;
  name: string;
  bucket_key: string;
  contact: number;
  project: number;
  item: number;
  action: number;
  url: string;
  status: string;
  signatures: Signature[];
}

export interface Signature {
  id: number;
  deleted: boolean;
  created_at: string;
  updated_at: string;
  status: string;
  signed: boolean;
  contact: number;
  ats_owner: Contact;
  attachment: number;
}

export interface VolumnChartData {
  // API data
  month: string;
  revenue: number;
  decided_jobs: number;
  won_jobs: number;

  // Computed data
  trailing_revenue: number;
  trailing_decided_jobs: number;
  trailing_won_jobs: number;
  win_rate: number;
  timeStamp: number;
}

export interface PricingChartData {
  // API data
  month: string;
  bid_revenue: number;
  bid_gp_plus: number;
  won_revenue: number;
  won_gp_plus: number;
  lost_revenue: number | null;
  lost_gp_plus: number | null;

  // Computed data
  three_m_bid_gmr_plus: number;
  three_m_win_gmr_plus: number;
  three_m_lost_gmr_plus: number;
  timeStamp: number;
}

export interface RevenueForecastChartData {
  month: string;
  awarded_projection: number;
  unweighted_projection: number;
  weighted_projection: number;
}

export interface WinRate {
  scope: string;
  name: string;
  win_rate: number;
  gmr: number;
  num_jobs: number;
}

export interface WinRates {
  market_segment_name: string;
  type_id: number;
  num_bids: number;
  bid_amount: number;
  win_rate: number;
}

export interface Quote {
  id: number;
  attachment: number;
  attachment_r: Attachment;
  project: number;
  manufacturer: string;
  model: string;
  quantity: string;
  net: string;
  net_freight: string;
  net_install: string;
  sell: string;
  sell_total: string;
  category: string;
  class: string;
  discount: string;
  list: string;
  weight: string;
}

export interface QuoteItem {
  id: number;
  created_at: Date;
  updated_at: Date;
  deleted: boolean;
  quote: number;
  vendor: number;
  item_num: string;
  spec: string[];
  quote_vendor_order: number;
  vendor_item?: number | null;
  vendor_r: Vendor;
  vendor_item_r: VendorItem;
  qty: number;
  net?: number | null;
  net_freight?: number | null;
  net_install?: number | null;
  sell?: number | null;
  sell_total?: number | null;
  category?: string | null;
  class?: string | null;
  discount?: string | null;
  list?: number | null;
  weight?: number | null;
  manufacturer: string;
  model: string;
  unit: string;
}

export interface QuoteVendor {
  id: number;
  created_at: Date;
  updated_at: Date;
  deleted: boolean;
  quote: number;
  vendor: number;
  vendor_r: Vendor;
  orders: QuoteVendorOrder[];
  net: number;
  net_install: number;
  net_freight: number;
  sell: number;
  sell_total: number;
  form: any;
}

export interface QuoteVendorOrder {
  id: number;
  created_at: Date;
  updated_at: Date;
  deleted: boolean;
  quote: number;
  quote_vendor: number;
  quote_vendor_r: QuoteVendor;
  vendor: number;
  vendor_r: Vendor;
  items: QuoteItem[];
  total: number;
  form: any;
  net?: number | null;
  net_install?: number | null;
  net_freight?: number | null;
  sell?: number | null;
  sell_total?: number | null;
  attachments?: Attachment[];
}

export interface Vendor {
  id: number;
  created_at: Date;
  updated_at: Date;
  deleted: boolean;
  name: string;
  subscription?: number | null;
  aliases: string;
  cash_discount: number;
  guaranteed_rebate: number;
  likely_growth_rebate: number;
  max_growth_rebate: number;
  next_price_increase: number | null;
  price_increase_date: string | null;
  substitutes?: string | null;
  notes?: string | null;
}

export interface VendorItem {
  id: number;
  created_at: Date;
  updated_at: Date;
  deleted: boolean;
  vendor: number;
  model: string;
  net?: number | null;
  net_freight?: number | null;
  net_install?: number | null;
  sell?: number | null;
  sell_total?: number | null;
  category?: string | null;
  class?: string | null;
  discount?: string | null;
  list?: number | null;
  weight?: number | null;
  manufacturer: string;
}
